const formatDuracion = (value) => {
  const modalidades = {
    "1_ano": "1 año",
    presencial: "Presencial",
    hibrida: "Híbrida",
  };

  if (modalidades[value]) return modalidades[value];

  // fallback automático
  return value
    ?.replace(/_/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());
};

const Duracion = ({ value }) => {
  if (!value) return null;

  return (
    <p>
     {formatDuracion(value)}
    </p>
  );
};

export default Duracion;